import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders, HttpRequest, } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
var MLPackagesService = /** @class */ (function (_super) {
    tslib_1.__extends(MLPackagesService, _super);
    function MLPackagesService(http) {
        var _this = _super.call(this, http, MapperService.mlPackageMap) || this;
        _this._endpoint = '/odata/MLPackages';
        _this._contentType = 'application/x-zip-compressed';
        return _this;
    }
    MLPackagesService.prototype.generateSignedUrlForModelUpload = function (fileName) {
        var payload = JSON.stringify({
            fileName: fileName,
            contentType: this._contentType,
        });
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.GenerateSignedUrlForMLPackageUpload", payload);
    };
    MLPackagesService.prototype.uploadModelToSignedUrl = function (file, signedUrl) {
        var req = new HttpRequest('PUT', signedUrl, file, {
            headers: new HttpHeaders({ 'Content-Type': this._contentType }),
            reportProgress: true,
        });
        return this._http.request(req);
    };
    MLPackagesService.prototype.createPackage = function (data, stagingUri) {
        var req = new HttpRequest('POST', this._endpoint + "/UiPath.Server.Configuration.OData.CreateMLPackage", this._populatMetaData(data, stagingUri));
        return this._http.request(req);
    };
    MLPackagesService.prototype.createPackageVersion = function (mlPackageId, data, stagingUri) {
        var req = new HttpRequest('POST', "/odata/MLPackageVersions('" + mlPackageId + "')/UiPath.Server.Configuration.OData.CreateMLPackageVersion", this._populatMetaData(data, stagingUri));
        return this._http.request(req);
    };
    MLPackagesService.prototype.checkUniqueMLPackageName = function (mlPackageName) {
        var endpoint = "/odata/MLPackages/UiPath.Server.Configuration.OData.CheckUniqueMLPackageName(mlPackageName='" + mlPackageName + "')";
        return this._http.get(endpoint);
    };
    MLPackagesService.prototype._populatMetaData = function (data, stagingUri) {
        var metaData = {
            ChangeLog: data.modelVersions[0].changeLog,
            Description: data.description,
            InputDescription: data.modelVersions[0].inputDescription,
            InputType: data.inputType,
            MlPackageLanguage: data.modelVersions[0].modelLanguage,
            Name: data.name,
            DisplayName: data.name,
            OutputDescription: data.modelVersions[0].outputDescription,
            ProcessorType: data.modelVersions[0].processorType,
            StagingUri: stagingUri,
        };
        var payload = { metadata: metaData };
        return JSON.stringify(payload);
    };
    return MLPackagesService;
}(ODataService));
export { MLPackagesService };
